import script from "./VErrorTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./VErrorTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./VErrorTooltip.vue?vue&type=style&index=0&id=cf9f9158&scoped=true&lang=postcss"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf9f9158"]])

export default __exports__